export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/56a1db1feb6cad17a1ad3f1fb382b11d.jpg')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            INSTITUTO DE CAPACITAÇÃO MINISTERIAL
          </h1>
          <p className="text-2xl md:text-3xl text-white/95 mb-12 font-light">
            A teologia a serviço da Palavra
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://wa.me/5567992870208"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-teal-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Inscreva-se Agora
            </a>
            <button
              onClick={() => {
                const element = document.getElementById('cursos');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
            >
              Conheça os Cursos
            </button>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">2017</div>
              <div className="text-white text-sm">Fundação</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">300+</div>
              <div className="text-white text-sm">Alunos Formados</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-lg p-6 border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">7+</div>
              <div className="text-white text-sm">Cursos Oferecidos</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
